/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 *
 * @author Mikhail Kokoulin
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.11.0
 * @since 1.0.0
 */
import { useEffect } from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Button, LinkBlock } from '../../../../components/common';
import ICommonTranslation from '../../../../modules/internationalization/types/common';
import {
    ModalPopupContainerStyled,
    ModalPopupControlContainer,
    ModalPopupTextStyled,
    ModalPopupTitleStyled,
} from '../../../../modules/modal/components/styled/ModalStyled';
import { loadAuthData } from '../../actions/authActions';

export interface IChangePasswordModal {
    closeBtn: string;
    closeModal: () => void;
    isOpen: boolean;
    link?: string;
    text: string;
    title: string;
    translations?: ICommonTranslation;
}

interface IConnected {
    loadAuthData: () => void;
}

// TODO create a basic modal window BBPORTAL-6459
export const ChangePasswordModal = (props: IChangePasswordModal & IConnected) => {
    useEffect(() => {
        return () => {
            props.loadAuthData();
        };
    }, []);

    return (
        <ModalPopupContainerStyled
            data-component={'modal-popup'}
            data-name={'change-password-modal'}>
            <ModalPopupTitleStyled data-name='modal-popup-title'>
                {props.title}
            </ModalPopupTitleStyled>
            <ModalPopupTextStyled data-name='modal-popup-text'>
                {props.text}
            </ModalPopupTextStyled>
            <ModalPopupTextStyled data-name='modal-popup-link'>
                <LinkBlock url={props.translations && props.translations.contextHelpLink}>{props.link}</LinkBlock>
            </ModalPopupTextStyled>
            <ModalPopupControlContainer>
                <Button data-name='close-button'
                        kind="mediumNormal"
                        onClick={props.closeModal}>
                    {props.closeBtn}
                </Button>
            </ModalPopupControlContainer>
        </ModalPopupContainerStyled>
    );
};

export const mapDispatchToProps = (dispatch: Dispatch) => ({
    loadAuthData: () => dispatch(loadAuthData()),
});

export default connect(null, mapDispatchToProps)(ChangePasswordModal);
